import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const StyledHeader = styled.header`
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  align-items: flex-end;
  padding: 10px 24px;
  height: 64px;
  width: 100%;
  box-sizing: border-box;
  z-index: 10;
  background: ${ThemePrisma.colors.lightblue[7]};

  .actions-container {
    display: flex;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    padding: 0px;
    gap: 16px;

    svg {
      cursor: pointer;
      color: ${ThemePrisma.colors.gray[4]};
    }
  }
`;

export const HeaderButton = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  gap: 24px;
  align-items: center;
  padding: 8px;
  border-radius: ${ThemePrisma.borderRadius['2xsmall']};
  transition: all 0.3s ease-in-out 0s;

  &:hover,
  .active {
    background: rgb(0 0 0 / 10%);
  }

  svg {
    color: ${ThemePrisma.colors.gray[4]};
  }
`;
